import { SectionWrapper } from '@/entities/widget';
import FlareIcon from '@/shared/assets/images/flare.svg';
import { BorderedBox } from '@/shared/ui/BorderedBox';
import type { MainTakeAwaySectionProps } from './MainTakeAwaySection.types';
import { useTranslation } from 'react-i18next';

export const MainTakeAwaySection = ({ mainTakeAway }: MainTakeAwaySectionProps) => {
  const { t } = useTranslation('audiences');

  if (!mainTakeAway || mainTakeAway.length === 0) {
    return null;
  }

  return (
    <SectionWrapper
      title={t('audienceFlowWidget.mainTakeAwaySection.mainTakeAway')}
      icon={FlareIcon}
      className="border-none"
    >
      <BorderedBox className="border-none bg-orange-50 px-10">
        <p className="text-body-md text-foreground">{mainTakeAway}</p>
      </BorderedBox>
    </SectionWrapper>
  );
};
